<template id="bannerTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>

    <!-- Snackbar -->
    <div id="snackbar" class="snackbar alert">{{serverMessage}}</div>

    <!-- Sticky Toolbar with Action Button -->
    <section class="toolbar">
      <h1>Home Banner</h1>
      <button
        type="button"
        class="btn btn-info"
        v-on:click="updateBanner()"
      >Save Changes</button>
    </section>

    <div class="main-div" :class="formState.invalidShake ? 'invalid' : ''">
      <!-- Loading -->
      <div class="spinner-wrapper" v-bind:class="formState.loading ? 'show' : 'hide'">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <p class="alert alert-danger text-left" v-if="errors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="error in errors" v-bind:key="error">{{ error }}</li>
        </ul>
      </p>

      <form class="banner-form col-12" :disabled="formState.loading">
        <div role="tablist">
          <b-card no-body class="col-12 mb-1 p-0">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-new'" variant="info">Add New Slide</b-button>
            </b-card-header>
            <b-collapse :id="'accordion-new'" accordion="my-accordion" role="tabpanel">
              <b-card-body class="row text-left"> 
                <!-- Title -->
                <div class="form-group col-sm-6">
                  <label for="title">Title</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="newSlide.title"
                    id="title"
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="title_en">Title (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="newSlide.title_en"
                    id="title_en"
                  />
                </div>

                <!-- Content/Description -->
                <div class="form-group col-sm-6">
                  <label for="content">Description</label>
                  <textarea
                    class="form-control"
                    id="content"
                    cols="30"
                    rows="3"
                    v-model="newSlide.content"
                    >
                  </textarea>
                </div>
                <div class="form-group col-sm-6">
                  <label for="content_en">Description (EN)</label>
                  <textarea
                    class="form-control"
                    id="content_en" 
                    cols="30"
                    rows="3"
                    v-model="newSlide.content_en"
                    >
                  </textarea>
                </div>

                <!-- Button Text -->
                <div class="form-group col-sm-6">
                  <label for="btn_text">Button Text</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="newSlide.btn_text"
                    id="btn_text"
                    
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="btn_text_en">Button Text (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="newSlide.btn_text_en"
                    id="btn_text_en"
                    
                  />
                </div>

                <!-- URL -->
                <div class="form-group col-sm-6">
                  <label for="btn_url">Button URL<br><small class="text-muted">*Example: contact, about, customizations</small></label>
                  <div class="form-inline">
                    <!--
                    -- TODO: Website URL must be changed in case we need a new instance on a different domain
                    -->
                    <span class="mr-1">ithoob.com/</span>
                    <input
                      class="form-control"
                      type="text"
                      v-model="newSlide.btn_url"
                      id="btn_url"
                    />
                  </div>
                </div>

                <!-- URL -->
                <div class="form-group col-sm-6">
                  <label for="btn_url">Text Color<br><small class="text-muted">Title And Description</small></label>
                    <input
                      class="form-control"
                      type="color"
                      v-model="newSlide.text_color.image"
                      id="btn_url"
                    />
                </div>

                <!-- Upload Image -->
                <div class="form-group col-sm-6">
                  <label for="img_upload">Upload Image<br><small class="text-muted">*1 : 0.54 (W : H) for banner image - Example: 1600x600</small></label>
                  <input
                    class="form-control"
                    type="file"
                    :id="'image_' + (data.slides.length + 1)"
                    @change="uploadFile('image_' + (data.slides.length + 1), (data.slides.length + 1), 'create')"
                  />
                </div>

                <!-- Upload Image -->
                <div class="form-group col-sm-6">
                  <label for="img_upload">Upload Mobile Image<br><small class="text-muted">*1 : 0.54 (W : H) for mobile banner image - Example: 800 * 480</small></label>
                  <input
                    class="form-control"
                    type="file"
                    :id="'mobile_image_' + (data.slides.length + 1)"
                    @change="uploadFile('mobile_image_' + (data.slides.length + 1), (data.slides.length + 1), 'mobile_create')"
                  />
                </div>


                <!-- Image Preview -->
                <div class="img-preview col-12">
                  <img :src="newSlide.image">
                </div>
                <div>
                  <button
                      type="button"
                      class="btn btn-info float-right"
                      v-on:click="createNewBanner()"
                    >Create New Slider</button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="col-12 mb-1 p-0" v-for="(slide, index) in this.data.slides" :key="index+1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle="'accordion-' + (index+1)" variant="info">Slide #{{index+1}}</b-button>
            </b-card-header>
            <b-collapse :id="'accordion-' + (index+1)" accordion="my-accordion" role="tabpanel">
              <b-card-body class="row text-left">
                
                  
                <!-- Title -->
                <div class="form-group col-sm-6">
                  <label for="title">Title</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="slide.title"
                    id="title"
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="title_en">Title (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="slide.title_en"
                    id="title_en"
                  />
                </div>

                <!-- Content/Description -->
                <div class="form-group col-sm-6">
                  <label for="content">Description</label>
                  <textarea
                    class="form-control"
                    id="content"
                    cols="30"
                    rows="3"
                    v-model="slide.content"
                    >
                  </textarea>
                </div>
                <div class="form-group col-sm-6">
                  <label for="content_en">Description (EN)</label>
                  <textarea
                    class="form-control"
                    id="content_en" 
                    cols="30"
                    rows="3"
                    v-model="slide.content_en"
                    >
                  </textarea>
                </div>

                <!-- Button Text -->
                <div class="form-group col-sm-6">
                  <label for="btn_text">Button Text</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="slide.btn_text"
                    id="btn_text"
                    
                  />
                </div>
                <div class="form-group col-sm-6">
                  <label for="btn_text_en">Button Text (EN)</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="slide.btn_text_en"
                    id="btn_text_en"
                    
                  />
                </div>

                <!-- URL -->
                <div class="form-group col-sm-6">
                  <label for="btn_url">Button URL<br><small class="text-muted">*Example: contact, about, customizations</small></label>
                  <div class="form-inline">
                    <!--
                    -- TODO: Website URL must be changed in case we need a new instance on a different domain
                    -->
                    <span class="mr-1">ithoob.com/</span>
                    <input
                      class="form-control"
                      type="text"
                      v-model="slide.btn_url"
                      id="btn_url"
                    />
                  </div>
                </div>

                <div class="form-group col-sm-6">
                  <label for="btn_url">Text Color<br><small class="text-muted">Title And Description</small></label>
                    <input
                      class="form-control"
                      type="color"
                      v-model="slide.text_color.image"
                      id="btn_url"
                    />
                </div>

                <!-- Upload Image -->
                <div class="form-group col-sm-6">
                  <label for="img_upload">Upload Image<br><small class="text-muted">*1 : 0.54 (W : H) for banner image - Example: 1600x600</small></label>
                  <input
                    class="form-control"
                    type="file"
                    :id="'image_' + index+1"
                    @change="uploadFile('image_' + index+1, index)"
                  />
                </div>

                <div class="form-group col-sm-6">
                  <label for="img_upload">Upload Mobile Image<br><small class="text-muted">*1 : 0.54 (W : H) for mobile banner image - Example: 800x480</small></label>
                  <input
                    class="form-control"
                    type="file"
                    :id="'mobile_image_' + index+1"
                    @change="uploadFile('mobile_image_' + index+1, index, 'mobile_update')"
                  />
                </div>


                <!-- Image Preview -->
                <div class="img-preview col-12">
                  <img :src="slide.image">
                </div>
                <div>
                  <button
                      type="button"
                      class="btn btn-danger pull-right"
                      v-on:click="deleteBanner(slide.id, slide.mobile_image.id, slide.text_color.id)"
                    >Delete Slide</button>
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </form>
    </div>
  </div>
</template>

<style lang='scss' scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Sans");
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

.toolbar {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  right: 0;
  padding: 10px 50px;
  background: #fff;
  border-bottom: 1px solid #eee;
  z-index: 99;
}

h1 {
  margin-bottom: 0;
}

.card {
  transition: all 150ms ease-in-out;

  &:hover {
    background: #fafafa;
  }
}

.img-preview {
  max-height: 500px;
  text-align: center;

  img {
    width: auto;
    max-width: 100%;
    height: 100%;
  }
}

.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}

.component-container {
  min-height: 100%;
  display: flex;
}

.main-div {
  margin-top: 50px;
  padding: 50px;
  width: 80%;
}

.spinner-wrapper {
  display: none;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 100%;
  top: 0;
  right: 0;
  background: rgba(230, 230, 230, 0.61);
  z-index: 99;
}
.spinner-wrapper.show {
  display: flex;
}
.spinner-wrapper.hide {
  display: none;
}

.spinner-border {
  width: 3.5rem;
  height: 3.5rem;
}

.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

/* The snackbar - position it at the bottom and in the middle of the screen */
.snackbar {
  position: fixed;
  bottom: -100px;
  left: 40%;
  z-index: 1;
  transition: all 300ms ease-in-out;
}

.snackbar.show {
  bottom: 30px;
  opacity: 1;
}
</style>

<script>
import axios from "axios";
import { getCookie } from "../cookie.js";
import { herokuUrl } from "../apiConfig";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "banner",
  data() {
    return {
      data: { slides: [] },
      newSlide: {
        image: "https://higuma.github.io/bootstrap-4-tutorial/img/slide-1.svg",
        type: "banner",
        mobile_image: {
          image: "https://higuma.github.io/bootstrap-4-tutorial/img/slide-1.svg",
        },
        text_color: {image:"#ffffff"}
      },
      errors: [], // Form's errors
      serverMessage: "",
      formState: {
        loading: false,
        invalidShake: false,
      },
      image: {
        uploaded: null,
        newFileUpload: null,
        value: null,
      },
    };
  },
  watch: {},
  mounted() {
    this.fetchBannerData();
  },
  methods: {
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function () {
          this.formState.invalidShake = false;
        }.bind(this),
        1000
      );
    },
    checkNewForm() {
      // Reset errors
      this.errors = [];

      // Limits
      let titleMax = 35;
      let descMax = 75;
      let btnTextMax = 25;
      let index = this.data.slides.length + 1;
      if (this.newSlide.title) {
        if (this.newSlide.title.length > titleMax) {
          this.errors.push(
            `Slide #${index} Title must be ${titleMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index} Title is required`);
      }
      if (this.newSlide.title_en) {
        if (this.newSlide.title_en.length > titleMax) {
          this.errors.push(
            `Slide #${index} Title (EN) must be ${titleMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index} Title (EN) is required`);
      }

      // Content
      if (this.newSlide.content) {
        if (this.newSlide.content.length > descMax) {
          this.errors.push(
            `Slide #${index} Description must be ${descMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index} Description is required`);
      }
      if (this.newSlide.content_en) {
        if (this.newSlide.content_en.length > descMax) {
          this.errors.push(
            `Slide #${index} Description (EN) must be ${descMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index} Description (EN) is required`);
      }

      // Button
      if (this.newSlide.btn_text) {
        if (this.newSlide.btn_text.length > btnTextMax) {
          this.errors.push(
            `Slide #${index} Button Text must be ${btnTextMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index + 1} Button Text is required`);
      }
      if (this.newSlide.btn_text_en) {
        if (this.newSlide.btn_text_en.length > btnTextMax) {
          this.errors.push(
            `Slide #${index} Button Text (EN) must be ${btnTextMax} characters maximum`
          );
        }
      } else {
        this.errors.push(`Slide #${index} Button Text (EN) is required`);
      }

      // URL
      if (!this.newSlide.btn_url) {
        this.errors.push(`Slide #${index} Button URL is required`);
      }

      // Image
      if (!this.newSlide.image) {
        this.errors.push(`Slide #${index} Image is required`);
      }
    },
    checkForm() {
      // Reset errors
      this.errors = [];

      // Limits
      let titleMax = 35;
      let descMax = 75;
      let btnTextMax = 25;

      // Loop over each slide given data, and check if they match the criteria or not
      this.data.slides.map((slide, index) => {
        if (slide.title) {
          if (slide.title.length > titleMax) {
            this.errors.push(
              `Slide #${index + 1} Title must be ${titleMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Title is required`);
        }
        if (slide.title_en) {
          if (slide.title_en.length > titleMax) {
            this.errors.push(
              `Slide #${
                index + 1
              } Title (EN) must be ${titleMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Title (EN) is required`);
        }

        // Content
        if (slide.content) {
          if (slide.content.length > descMax) {
            this.errors.push(
              `Slide #${
                index + 1
              } Description must be ${descMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Description is required`);
        }
        if (slide.content_en) {
          if (slide.content_en.length > descMax) {
            this.errors.push(
              `Slide #${
                index + 1
              } Description (EN) must be ${descMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Description (EN) is required`);
        }

        // Button
        if (slide.btn_text) {
          if (slide.btn_text.length > btnTextMax) {
            this.errors.push(
              `Slide #${
                index + 1
              } Button Text must be ${btnTextMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Button Text is required`);
        }
        if (slide.btn_text_en) {
          if (slide.btn_text_en.length > btnTextMax) {
            this.errors.push(
              `Slide #${
                index + 1
              } Button Text (EN) must be ${btnTextMax} characters maximum`
            );
          }
        } else {
          this.errors.push(`Slide #${index + 1} Button Text (EN) is required`);
        }

        // URL
        if (!slide.btn_url) {
          this.errors.push(`Slide #${index + 1} Button URL is required`);
        }

        // Image
        if (!slide.image) {
          this.errors.push(`Slide #${index + 1} Image is required`);
        }
      });
    },
    fetchBannerData() {
      // Show Loader
      this.formState.loading = true;

      // Get Slides Data
      return axios
        .get(`${herokuUrl}/dashboard/banner`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        })
        .then((res) => {
          this.data = res.data;

          // Stop the loader
          this.formState.loading = false;
          console.log(res.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            logOut();
          } else {
            this.formState.loading = false;
            alert("Banner fetching failed, " + err.response.data.message);
            // console.log(err);
          }
        });
    },
    compress(elem, sizeW, sizeH, compressedFileObj) {
      const width = sizeW;
      const height = sizeH;
      const fileName = elem.files[0].name;
      const reader = new FileReader();
      // console.log(elem.files[0]);
      reader.readAsDataURL(elem.files[0]);
      return (reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        (img.onload = () => {
          const elem = document.createElement("canvas");
          elem.width = width;
          elem.height = height;
          const ctx = elem.getContext("2d");
          // img.width and img.height will contain the original dimensions
          ctx.drawImage(img, 0, 0, width, height);
          ctx.canvas.toBlob(
            (blob) => {
              const file = new File([blob], fileName, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              compressedFileObj.flag = true;
              compressedFileObj.file = file;
            },
            "image/jpeg",
            1
          );
        }),
          (reader.onerror = (error) => {
            compressedFileObj.flag = "error";
            console.log(error);
          });
      });
    },
    /**
     * TODO: This function uploads the file directly to the server. Without confirming first.
     * It must upload the image after submitting the form.
     *
     * [WHY] User might try to upload multiple images for testing purposes, without submitting.
     * This will pump the server with too many unused images.
     */
    uploadFile(imgName, index, type = "update") {
      console.log(imgName);
      console.log(type);
      console.log(document.getElementById(imgName).files[0].name);
      if (
        !(
          document.getElementById(imgName).files[0] &&
          document.getElementById(imgName).files[0].name
        )
      )
        return;
      this.formState.loading = true;
      this.image.uploaded = false;
      let checkObj = { file: null, flag: false };
      let width = 1600;
      let height = 600;
      if(type === "mobile_update" || type === "mobile_create"){
        width = 800;
        height = 480;
      }
      this.compress(document.getElementById(imgName), width, height, checkObj);
      // let file = document.getElementById("image").files[0];
      let fn = () => {
        if (checkObj.flag && checkObj.flag != "error") {
          this.image.newFileUpload = new FormData();
          this.image.newFileUpload.set("images", checkObj.file);
          axios
            .post(`${herokuUrl}/adminUpload`, this.image.newFileUpload, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: getCookie("user"),
              },
            })
            .then((res) => {
              if (res.data.status) {
                this.image.uploaded = true;
                this.image.value = res.data.sources[0];
                this.formState.loading = false;
                // Add the uploaded image path to its slide object
                if (type === "create") {
                  this.newSlide.image = res.data.sources[0];
                }else if (type === "mobile_create") {
                  this.newSlide.mobile_image.image = res.data.sources[0];
                }else if (type === "mobile_update") {
                  this.data.slides[index].mobile_image.image = res.data.sources[0];
                } else {
                  this.data.slides[index].image = res.data.sources[0];
                }
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " + res.message
                );
                this.formState.loading = false;
              }
            })
            .catch((err) => {
              if (err.response.status == 401) {
                logOut();
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " +
                    err.response.data.message
                );
                this.formState.loading = false;
              }
            });
        } else if (checkObj.flag == "error") {
          alert("Compression Error");
          this.formState.loading = false;
        } else {
          setTimeout(fn, 200);
        }
      };
      fn();
    },
    createNewBanner() {
      // Check if form is validated
      this.checkNewForm();

      // If there's any error, shake the form. If not, start the update process
      if (!this.errors.length) {
        let snackbar = document.getElementById("snackbar");
        this.formState.loading = true;

        return axios
          .post(`${herokuUrl}/dashboard/create-banner-slide`, this.newSlide, {
            headers: {
              Authorization: getCookie("user"),
            },
          })
          .then(() => {
            this.formState.loading = false;
            this.newSlide = {
              image: "https://higuma.github.io/bootstrap-4-tutorial/img/slide-1.svg",
              type: "banner",
            }
            this.serverMessage = "This section has been updated successfully";
            snackbar.className = "snackbar show alert alert-success";
            snackbar.classList.remove("alert-danger"); // If exist, it will be deleted
            snackbar.classList.add("show", "alert-success");
            setTimeout(function () {
              snackbar.className = snackbar.className.replace("show", "");
            }, 3000);

            // this.partiallyResetForm();
            this.fetchBannerData();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;

              this.serverMessage =
                "There was a problem, and we create your banner";
              snackbar.classList.remove("alert-success"); // If exist, it will be deleted
              snackbar.classList.add("show", "alert-danger");
              setTimeout(function () {
                snackbar.className = snackbar.className.replace("show", "");
              }, 3000);
            }
          });
      } else {
        this.shakeForm();
      }
    },
    deleteBanner(id, mobile_id, color_id) {
      

      // If there's any error, shake the form. If not, start the update process
      if (id) {
        let snackbar = document.getElementById("snackbar");
        this.formState.loading = true;

        return axios
          .post(
            `${herokuUrl}/dashboard/delete-banner-slide`,
            { id, mobile_id, color_id },
            {
              headers: {
                Authorization: getCookie("user"),
              },
            }
          )
          .then(() => {
            this.formState.loading = false;

            this.serverMessage = "This section has been deleted successfully";
            snackbar.className = "snackbar show alert alert-success";
            snackbar.classList.remove("alert-danger"); // If exist, it will be deleted
            snackbar.classList.add("show", "alert-success");
            setTimeout(function () {
              snackbar.className = snackbar.className.replace("show", "");
            }, 3000);

            // this.partiallyResetForm();
            this.fetchBannerData();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;

              this.serverMessage =
                "There was a problem, while deleting your banner";
              snackbar.classList.remove("alert-success"); // If exist, it will be deleted
              snackbar.classList.add("show", "alert-danger");
              setTimeout(function () {
                snackbar.className = snackbar.className.replace("show", "");
              }, 3000);
            }
          });
      } else {
        this.shakeForm();
      }
    },
    updateBanner() {
      // Check if form is validated
      this.checkForm();

      // If there's any error, shake the form. If not, start the update process
      if (!this.errors.length) {
        let snackbar = document.getElementById("snackbar");
        this.formState.loading = true;

        return axios
          .post(
            `${herokuUrl}/dashboard/update-banner-slides`,
            this.data.slides,
            {
              headers: {
                Authorization: getCookie("user"),
              },
            }
          )
          .then(() => {
            this.formState.loading = false;

            this.serverMessage = "This section has been updated successfully";
            snackbar.className = "snackbar show alert alert-success";
            snackbar.classList.remove("alert-danger"); // If exist, it will be deleted
            snackbar.classList.add("show", "alert-success");
            setTimeout(function () {
              snackbar.className = snackbar.className.replace("show", "");
            }, 3000);

            // this.partiallyResetForm();
            // this.fetchAllplaces();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;

              this.serverMessage =
                "There was a problem, and we couldn't update your banner";
              snackbar.classList.remove("alert-success"); // If exist, it will be deleted
              snackbar.classList.add("show", "alert-danger");
              setTimeout(function () {
                snackbar.className = snackbar.className.replace("show", "");
              }, 3000);
            }
          });
      } else {
        this.shakeForm();
      }
    },
  },
  components: {
    appNavigation: Navigation,
  },
};
</script>
